module.exports = __webpack_public_path__ + "static/media/jira.70365e83.svg";